/* eslint-disable @typescript-eslint/naming-convention */

/**
 * User title
 */
export enum Title {
    MALE = 'Herr',
    FEMALE = 'Frau',
}

/**
 * LM Fields
 */
export enum LmFields {
    SALUTATION = 'salutation',
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    EMAIL = 'email',
}

/**
 * Type of lm error notifications
 */
export enum LmErrorNotification {
    GENERAL,
    MISSING_INPUT,
}

/**
 * LM Actions
 */
export enum LmFormAction {
    SUBMIT_LM_FORM = 'CABLE/LM/SUBMIT_LM_FORM',
    HANDLE_LM_RESPONSE = 'CABLE/LM/HANDLE_LM_RESPONSE',
    HANDLE_LM_RESPONSE_ERROR = 'CABLE/LM/HANDLE_LM_RESPONSE_ERROR',
    CHANGE_LM_INPUT = 'CABLE/LM/CHANGE_LM_INPUT',
    CLEAR_LM_RESULT = 'CABLE/LM/CLEAR_LM_RESULT',
}
